import React,{useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GetSearchData } from '../Redux/Slice/DataSlice'
import { useNavigate } from 'react-router-dom';


const SearchHeader = () => {
  const Navigate=useNavigate()
  const {Brands,Categories,Cardetails}=useSelector((state)=>state.CarData)
  const Dispatch=useDispatch()
  const [searchData, setsearchData] = useState({
    carName:"",
    Category:"",
    Brand:"",
    Price:""   
  })

  const handleclick=(event)=>{
    setsearchData((old)=>{
      return{
        ...old,[event.target.name]:event.target.value
      }
    })
  }

  const SearchButton=()=>{
    Dispatch(GetSearchData(searchData))
    Navigate('/cars')
  }
  


  return (
    <section class=" h-[70vh] w-[100%]  carslider  ">
  

  <div class="flex h-full w-[100%] items-center justify-center container mx-auto px-8 ">
    <div class=" w-[100%] text-center">
      <h1 class="text-3xl sm:text-5xl capitalize tracking-widest text-white lg:text-4xl">Search Your Dream CAR</h1>

      <div class="mt-8 flex flex-col space-y-3 sm:-mx-2 sm:flex-row sm:justify-center sm:space-y-0 sm:w-auto w-[100%] ">
      <input id="email" name='carName' list="Cars" value={searchData.carName}  onChange={handleclick}  type="search" class="rounded-md border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 sm:mx-2 mx-2 " placeholder="Search Cars" />

<datalist id="Cars">
{
  Cardetails && Cardetails.map((x)=>{
    return(
      <option value={x.Name}>{x.Name}</option>
    )
  })
}  
    </datalist>

        <div class="flex flex-row flex-wrap justify-center items-center  m-2 ">
                        <div class="m-1 w-[100%] sm:w-auto ">
                        <select name='Category' value={searchData.Category} onChange={handleclick} class="rounded-md sm:w-auto w-[100%] border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 ">
                                <option selected  className='bg-black '>Vehical Types</option>
                                {
                                  Categories.map((x)=>{
                                    return(
                                    <option value={x.Categories} className='bg-black  text-white'>{x.Categories}</option>
                                    )

                                  })
                                }
                               
                            </select>
                        </div>

                       
                        <div class="m-1 w-[100%] sm:w-auto">
                        <select name='Brand' value={searchData.Brand} onChange={handleclick} class=" sm:w-auto w-[100%] rounded-md border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 sm:mx-2">
                                <option selected className='p-1 bg-black'>Brand</option>
                                {
                                   Brands.map((x)=>{
                                    return(
                                    <option value={x.Brand} className='bg-black '>{x.Brand}</option>
                                    )

                                  })
                                }
                            </select>
                        </div>
      


                        </div>
                       
                        <button class=" transform rounded-md bg-green-500 px-8 py-2 text-sm font-medium capitalize tracking-wide text-white transition-colors duration-200 hover:bg-blue-600 focus:bg-blue-600 focus:outline-none sm:mx-2 mx-2" onClick={SearchButton}>Search</button>
                     

                        
      
      
      </div>
    </div>
  </div>

  
</section>
  )
}

export default SearchHeader